import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { AppThemeType } from "src/types/apps";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";
import { GetAppCustomPayload } from "./NetTypes";

async function getAppCustomizationRequest({ orgId, appId, type }: GetAppCustomPayload) {
	return await apiClient
		.get(API.QUERY.ORGANIZATIONS.CUSTOMIZATION(orgId, appId), { params: { type } })
		.then((res) => res.data);
}

export function useGetAppCustomizationRequest(payload: GetAppCustomPayload) {
	return useQuery<AppThemeType, AxiosError>({
		queryKey: ["apps", "custom", payload.appId],
		queryFn: () => getAppCustomizationRequest(payload)
	});
}
